import { render, staticRenderFns } from "./ProductCreateForm.vue?vue&type=template&id=bb466fbc&"
import script from "./ProductCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProductCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports